import Transaction from '@/classes/transactions/Transaction'

export default class Transactions extends Array {
  constructor (transactions, ...rest) {
    Array.isArray(transactions) ? super(...transactions.map(transaction => new Transaction(transaction))) : super(...rest)
  }
}
